import { TicketCategory, TicketStatus } from "generated/graphql";
import { ParseKeys } from "i18next";
import { TabKey } from "./types";

// Slow fallback only; the supportTicketChanged subscription is what keeps the
// list and thread live.
export const TICKETS_POLL_MS = 60000;

export const ATTACHMENT_FOLDER = "support-attachments";
export const MAX_SUBJECT_LENGTH = 150;

export const CATEGORY_LABELS: Record<TicketCategory, ParseKeys<"support">> = {
  [TicketCategory.Account]: "category.account",
  [TicketCategory.Quotes]: "category.quotes",
  [TicketCategory.Bookings]: "category.bookings",
  [TicketCategory.Billing]: "category.billing",
  [TicketCategory.GoogleListing]: "category.google_listing",
  [TicketCategory.Bug]: "category.bug",
  [TicketCategory.Other]: "category.other",
};

export const STATUS_LABELS: Record<TicketStatus, ParseKeys<"support">> = {
  [TicketStatus.Open]: "status.open",
  [TicketStatus.InProgress]: "status.in_progress",
  [TicketStatus.Resolved]: "status.resolved",
};

export const STATUS_COLORS: Record<TicketStatus, string> = {
  [TicketStatus.Open]: "#1976d2",
  [TicketStatus.InProgress]: "#ed6c02",
  [TicketStatus.Resolved]: "#2e7d32",
};

export const SUPPORT_TABS: { label: ParseKeys<"support">; path: TabKey }[] = [
  { label: "tabs.open", path: "open" },
  { label: "tabs.resolved", path: "resolved" },
  { label: "tabs.all", path: "all" },
];
